import _ from "lodash";
import {MoneyHelper} from "../../../components/util/money";

function normaliseUiCampaigns(campaigns: any) {
  if (_.isArray(campaigns)) {
    return _.compact(_.map(campaigns, function(campaign: any) {
      if (!_.isObject(campaign)) {
        return null;
      }
      const c: any = campaign;
      return {
        campaignName: _.isString(c.campaignName) ? c.campaignName : '',
        budget: _.isObject(c.budget) ? c.budget : {}
      };
    }));
  }

  if (!_.isObject(campaigns)) {
    return [];
  }

  return _.map(campaigns, function(val: any, key: any) {
    return {
      campaignName: key,
      budget: _.isObject(val) ? val : {}
    };
  });
}

export const convertToUiBudgets = function(workingObj: any) {
  return _.compact((workingObj.politicalBudgets || []).map((pb: any) => {
    if (!_.isObject(pb)) {
      return null;
    }
    const budget: any = pb;
    budget.campaigns = normaliseUiCampaigns(budget.campaigns);
    return budget;
  }));
};

export const convertToApiBudgets = function(workingObj) {
  return _.compact((workingObj || []).map((pb) => {
    const camps = _.filter(pb.campaigns || [], function(c) {
      return c.campaignName && MoneyHelper.isMoney(c.budget);
    });
    const apiBudget = _.assign({}, pb, {campaigns: {}});
    _.forEach(camps, function(c) {
      apiBudget.campaigns[c.campaignName] = c.budget;
    });
    return pb.election && MoneyHelper.isMoney(pb.totalBudget) ? apiBudget : null;
  }));
};

export function doTheCopyOfEntity(model, entity) {
  entity.legalName = model.legalName || entity.legalName;
  entity.legalEntity = model.type || entity.legalEntity;
  entity.contactEmail = model.email || entity.contactEmail;
  entity.url = model.advertiserUrl || entity.url;
  entity.vatId = model.vatId || entity.vatId;
  entity.address = model.address || entity.address;
}

function entityHasValue(entity) {
  const entityForTesting = _.cloneDeep(entity);
  if (entityForTesting.same) {
    return false;
  }
  delete entityForTesting.type;
  delete entityForTesting.address;
  delete entityForTesting.$$hashKey;
  return _.some(entityForTesting) || _.some(_.get(entity, 'address', {}));
}

export const convertToApiEntities = function(workingObj) {
  workingObj.entities = [];
  if (entityHasValue(workingObj.controllingEntity)) {
    if (!workingObj.controllingEntity.legalEntity) {
      delete workingObj.controllingEntity.legalEntity;
    }
    workingObj.entities.push(workingObj.controllingEntity);
  }
  if (entityHasValue(workingObj.payingEntity)) {
    if (!workingObj.payingEntity.legalEntity) {
      delete workingObj.payingEntity.legalEntity;
    }
    workingObj.entities.push(workingObj.payingEntity);
  }
};

function newEntity(type) {
  return {type: type, legalName: '', legalEntity: '', address: {}, contactEmail: '', url: '', vatId: ''};
}

export const convertToUiEntities = function(workingObj) {
  const emptyControllingEntity = newEntity('CONTROLLING');
  const controllingEntity = (workingObj.entities || []).find((entity) => {
    return entity.type === 'CONTROLLING';
  }) || emptyControllingEntity;
  const emptyPayingEntity = newEntity('PAYING');
  const payingEntity = (workingObj.entities || []).find((entity) => {
    return entity.type === 'PAYING';
  }) || emptyPayingEntity;
  workingObj.controllingEntity = controllingEntity;
  workingObj.payingEntity = payingEntity;

  // this is all to paper over the fact that the API doesn't like nulls
  [workingObj.controllingEntity, workingObj.payingEntity].forEach(entity => {
    entity.legalName = entity.legalName || '';
    entity.legalEntity = entity.legalEntity || '';
    entity.contactEmail = entity.contactEmail || '';
    entity.url = entity.url || '';
    entity.vatId = entity.vatId || '';
  });
  [workingObj.controllingEntity, workingObj.payingEntity].forEach(entity => {
    entity.hasValue = entityHasValue(entity);
    entity.same = !entity.hasValue;
  });
};

export const budgetSetUp = function(location, ctrl) {
  ctrl.availableCurrencies = ['DKK', 'EUR', 'NOK', 'SEK'];
  if (location.hostname === 'localhost') {
    ctrl.availableCurrencies.push('AUD');
  }

  ctrl.addElectionBudget = function() {
    ctrl.editsMade();
    ctrl.model.uiPoliticalBudgets = ctrl.model.uiPoliticalBudgets || [];
    ctrl.model.uiPoliticalBudgets.push({});
  };

  ctrl.removeElection = function($index) {
    ctrl.editsMade();
    _.pullAt(ctrl.model.uiPoliticalBudgets, $index);
  };

  ctrl.removeCampaign = function(budget, $index) {
    ctrl.editsMade();
    _.pullAt(budget.campaigns, $index);
  };

  ctrl.addCampaign = function(budget) {
    ctrl.editsMade();
    budget.campaigns = budget.campaigns || [];
    budget.campaigns.push({
      campaignName: '',
      budget: {}
    });
  };

  ctrl.removeEntity = function($index) {
    ctrl.editsMade();
    _.pullAt(ctrl.model.entities, $index);
  };

  ctrl.addEntity = function() {
    ctrl.editsMade();
    ctrl.model.entities = ctrl.model.entities || [];
    ctrl.model.entities.push({
      type: 'CONTROLLING',
      legalName: '',
      contactEmail: '',
      url: '',
      vatId: '',
      address: {}
    });
  };
};
